import { ReactElement, memo } from 'react';
import Tooltip from '@mui/material/Tooltip';

import { useOrderReceivedStateInfo } from '~hooks/index';

import { OrderReceivedStateChipProps } from './types';
import { OrderReceivedStateChipRoot } from './styles';

const OrderReceiveStateChip = ({
  collectItemStateTypeId,
  size = 'medium',
}: OrderReceivedStateChipProps): ReactElement => {
  const { description, color, tooltipMessage } = useOrderReceivedStateInfo(
    collectItemStateTypeId,
  );

  return (
    <Tooltip title={tooltipMessage} arrow>
      <OrderReceivedStateChipRoot
        variant="filled"
        label={description}
        color={color}
        size={size}
      />
    </Tooltip>
  );
};

export default memo(OrderReceiveStateChip);
